import { action, atom, noop } from '@reatom/framework'
import i18next from 'i18next'

import { AsyncStateN, Result } from '@blade/std-lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { WrongCredentialsError } from '../../auth-errors'

import type { Redacted } from '@blade/std-lib'

import { reatomUpdatePassword } from './index'

export type EditPasswordStage =
  | {
      type: 'current-password'
    }
  | {
      type: 'new-password'
      currentPassword: Redacted.Redacted
    }
  | {
      currentPassword: Redacted.Redacted
      newPassword: Redacted.Redacted
      type: 'repeat'
    }

export const reatomPasswordEditFlow = () => {
  const passwordUpdatedEvent = action(noop, 'passwordUpdatedEvent')
  const stageAtom = atom<EditPasswordStage>(
    { type: 'current-password' },
    'stageAtom',
  )

  const { updatePasswordAction, updatePasswordStateAtom } =
    reatomUpdatePassword()

  const checkPasswordStateAtom = atom(
    AsyncStateN.success(undefined),
    'checkPasswordStateAtom',
  )
  // const { checkPasswordAction, checkPasswordStateAtom } =
  //   reatomCheckCurrentPassword()

  const checkCurrentPasswordAction = action(
    async (ctx, currentPassword: Redacted.Redacted) => {
      // Check for account password not supported
      // const result = await ctx.schedule(() =>
      //   checkPasswordAction(ctx, currentPassword),
      // )

      // if (Result.isFailure(result)) {
      //   showSnackbarAction(ctx, {
      //     text: i18next.t('settings.password.toast-wrong'),
      //     intent: 'error',
      //   })
      //   return
      // }

      stageAtom(ctx, { type: 'new-password', currentPassword })
    },
    'checkCurrentPasswordAction',
  )

  const setNewPasswordAction = action(
    async (ctx, newPassword: Redacted.Redacted) => {
      const stage = ctx.get(stageAtom)
      if (stage.type !== 'new-password') {
        return
      }
      stageAtom(ctx, {
        type: 'repeat',
        currentPassword: stage.currentPassword,
        newPassword: newPassword,
      })
    },
    'setNewPasswordAction',
  )

  const confirmNewPasswordAction = action(
    async (ctx, password: Redacted.Redacted) => {
      const stage = ctx.get(stageAtom)
      if (stage.type !== 'repeat') {
        return
      }

      const result = await ctx.schedule(() =>
        updatePasswordAction(ctx, stage.currentPassword, password),
      )

      if (Result.isSuccess(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('settings.password.toast-changed'),
          intent: 'success',
        })
        passwordUpdatedEvent(ctx)
        return
      }

      if (result.failure instanceof WrongCredentialsError) {
        showSnackbarAction(ctx, {
          text: i18next.t('settings.password.toast-wrong'),
          intent: 'error',
        })
        stageAtom(ctx, { type: 'current-password' })
        return
      }

      showErrorSnackbarAction(ctx, result.failure)
    },
    'confirmNewPasswordAction',
  )

  return {
    passwordUpdatedEvent,
    stageAtom,
    checkCurrentPasswordAction,
    setNewPasswordAction,
    confirmNewPasswordAction,
    updatePasswordStateAtom,
    checkPasswordStateAtom,
  }
}

export type PasswordEditFlowReatom = ReturnType<typeof reatomPasswordEditFlow>
